export default {
  pinInputField: {
    flexGrow: 1,
    background: 'white',
  },
};
